import { HTMLAttributes } from 'react';

interface CardFormProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'dotted';
}

export const CardForm = ({
  className,
  variant = 'default',
  ...props
}: CardFormProps) => {
  const styleBorder = {
    dotted: 'bg-gray-50 border-dotted',
    default: 'bg-zinc-900 border-solid',
  };

  return (
    <div
      className={`${styleBorder[variant]} shadow-xs border border-zinc-800 rounded-sm p-6 relative ${className}`}
      {...props}
    />
  );
};
